module.exports = __webpack_public_path__ + "img/login-v7.50c52f83.svg";